import { useNavigate } from 'react-router-dom'
import './homepage.scss';
import { useContext, useEffect } from 'react';
import { AppContext } from '../../modules/appContext/AppContext';
import { listModule } from './constant';
import { Col, Row } from 'react-bootstrap';

export function HomePage() {
  const navigate = useNavigate();
  const { setIsLoading } = useContext(AppContext);
  const handleButtonClick = (to: string) => {
    navigate(to)
  };

  const handleGetDsDanhMuc = async () => {
    // try {
    //   const responseDsDanhmuc: IDanhSachDanhMuc = await getIndexedDBItem(KEY_DS_DANH_MUC_TIEP_DON);
    //   let hasEmptyArray = responseDsDanhmuc && Object.values(responseDsDanhmuc).some(
    //     (item: any[]) => item.length === 0
    //   );
    //   if (!responseDsDanhmuc || hasEmptyArray) {
    //     handleCacheDsDanhMuc();
    //   }
    // } catch (error) {
    //   console.error(error);
    // }
  };

  useEffect(() => {
    handleGetDsDanhMuc();
  }, []);

  return (
    <div className='main'>
      <div className='container'>
        <div>
          <p className='text-uppercase text-center text-white fw-normal heading-3 mb-15'>Phần mềm quản lý kho</p>
        </div>
        <div className='button-group'>
          <Row className='d-flex justify-content-center'>
            {listModule.map((item: any, index: number) => (
              <Col xs="3" className='item-button' key={index}>
                  <button
                    className='btn btn-light-primary fw-bolder btn-homepage'
                    onClick={() => handleButtonClick(item?.to)}>
                    <img src={item?.imgSrc} alt={item?.name}></img>
                  </button>
                  <span className='title-button'>{item?.name}</span>
              </Col>
            ))}
          </Row>
        </div>
      </div>
    </div>
  );
}